import {Box, BoxProps} from "@mui/material";
import {PropsWithChildren} from "react";
import {colors, radii, shadows, spacing} from "../theme";

type CardVariant = "default" | "glass" | "shadow";

type CardProps = PropsWithChildren<BoxProps> & {
  variant?: CardVariant;
};

const variantStyles = {
  default: {
    backgroundColor: colors.white,
    border: `1px solid ${colors.tertiary[300]}`,
  },
  shadow: {
    backgroundColor: colors.tertiary[100],
    boxShadow: `inset 0px 1px 30px rgba(255,255,255,0.38), ${shadows.card}`,
  },
  glass: {
    border: `1px solid ${colors.tertiary[300]}`,
    backdropFilter: "blur(10px)",
    boxShadow: `inset 0px 1px 30px rgba(255,255,255,0.38), ${shadows.glass}`,
  },
};

export const Card = ({children, variant = "default", sx, ...props}: CardProps) => (
  <Box
    sx={{
      borderRadius: radii.base,
      padding: spacing[6],
      display: "flex",
      flexDirection: "column",
      gap: spacing[4],
      width: "100%",
      overflow: "hidden",
      ...variantStyles[variant],
      ...(props.onClick && {cursor: "pointer"}),
      ...sx,
    }}
    {...props}
  >
    {children}
  </Box>
);
